<template>
    <LayoutBase>
        <chronological :key="group.id" :group="group" v-if="group.type == 1" :category="category"></chronological>
        <knowledge-base :key="group.id" :group="group" v-if="group.type == 2 && !category"></knowledge-base>
        <knowledge-base-category :key="group.id" :group="group" v-if="group.type == 2 && category" :category="category"></knowledge-base-category>
        <files v-if="group.type == 3" :category="category"></files>
        <events :key="group.id" :group="group" v-if="group.type == 4" :category="category"></events>
        <forum :key="group.id" :group="group" v-if="group.type == 5" :category="category"></forum>
    </LayoutBase>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import LayoutBase from '../../layouts/LayoutBase';
    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                category: null,
            }
        },
        computed: {
            ...mapState({
                group: state => state.group.group,
            })
        },
        created() {
            if(this.group.name === null || this.group.slug != this.$route.params.group){
                this.getGroup( this.$route.params.group );
            }

            if(this.$route.params.category){
                this.category = this.$route.params.category;
            }
        },
        methods: {
            ...mapActions({
                getGroup: 'group/getGroup',
            }),
        },
        beforeRouteUpdate (to, from, next) {
            this.getGroup(to.params.group);

            if(to.params.category !== null){
                this.category = to.params.category;
                this.$store.commit('group/setActiveCategory', to.params.category);
            }else{
                this.category = null;
                this.$store.commit('group/setActiveCategory', null);
            }

            next();
        },
        beforeRouteLeave (to, from, next) {
            if(to.params.group){
                this.getGroup(to.params.group);
            }

            if(to.params.category !== null){
                this.category = to.params.category;
                this.$store.commit('group/setActiveCategory', to.params.category);
            }else{
                this.category = null;
                this.$store.commit('group/setActiveCategory', null);
            }

            next();
        }
    }
</script>